// @ts-nocheck
import { _,sha1 } from '../../vendor'

/**
 * @function getUrlParameter
 * @param { string } sParam
 * @return { string }
 */
export const getUrlParameter = (sParam: any): string|true|undefined => {

    let sPageURL: string = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables: string[] = sPageURL.split('&'),
        sParameterName: any;

    if (sURLVariables.length <= 0){
        return '';
    }

    for (let i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : _.escape(sParameterName[1]);
        }
    }
};

export const generateClientHash = (client_id: any): string => {
    return client_id.toString() + sha1(
        btoa((parseInt(client_id) * 7532 + parseInt(client_id)).toString()))

   // SHA1(BASE64({client_id} * 7532 + {client_id}))
}

export const verifyClientHash = (hash: any): boolean => {
    let hash_length: number = hash.length - 40;
    let client_id: number = parseInt(hash.substr(0,hash_length));
    return (generateClientHash(client_id) == hash);
}

export const getClientIdFromHash = (hash: any): number|false => {
    let hash_length: number = hash.length - 40;
    if(verifyClientHash(hash)){
        return (parseInt(hash.substr(0,hash_length)));
    }
    return false;
}

/**
 * Returns any prefix for the active host environment
 * @return {string} e.g. 'test-' / 'staging-'
 */
export const getEnvPrefix = (): string => {

    let host: string = '';

    if (document.location.host.toLowerCase().indexOf('test-web.inbooma.net') >= 0
        || document.location.host.toLowerCase().indexOf('localhost') >= 0) {
      host = 'test-';
    }

    if (document.location.host.toLowerCase().indexOf('staging-web.inbooma.net') >= 0
        || (document.location.host.toLowerCase().indexOf('localhost') >= 0)
        && document.location.host.toLowerCase().indexOf('staging') >= 0) {
      host = 'staging-';
    }

    return host;
}

/**
 * @function parseUrlIntoObject
 * Uncomplete helper that soon will be moved elsewhere
 * 
 * @param {string} url
 * @return {string}
 */
export const parseUrlIntoObject: (url?: string) => any = (url: string = window.location.href): any => { // || Backbone.history.location
    
    let request: any = {};
    const pairs: any = url.split('&');

    for (let i: number = 0; i < pairs.length; i++) {
      if(!pairs[i])
         continue;
      const pair = pairs[i].split('=');
      request[_.escape(decodeURIComponent(pair[0]))] = _.escape(decodeURIComponent(pair[1]));
    }

    return request;
}